import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { ModalBaseStyles } from "../Common/styles/modal";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import { AxiosResponse } from "axios";
import http from "../../utils/http";

const DeleteNotificationModal = ({ data, closeModal, refresh }: any) => {
  const [submitLoader, setSubmitLoader] = useState(false);
  const handleSubmit = async () => {
    try {
      setSubmitLoader(true);

      let url;
      if (data?.type === "chat") {
        url = `/notifications/chat/delete?code=${data?.data}`;
      } else {
        url = `/notifications/${data?.data}`;
      }

      const res: AxiosResponse = await http.delete(url);
      toastMessage("success", res.data.message);
      closeModal();
      refresh();
      setSubmitLoader(false);
    } catch (err) {
      setSubmitLoader(false);
      closeModal();
      refresh();
      errorToastMessage(err as Error);
    }
  };

  return (
    <Modal open={data?.data ? true : false}>
      <Box
        sx={{
          ...ModalBaseStyles,
          minHeight: 0,
          width: "max-content",
          p: 4,
        }}
      >
        <Typography variant="subtitle2" fontWeight="medium" mt={1.5}>
          Are you sure you want to delete this notification?
        </Typography>
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 3 }}
        >
          {!submitLoader ? (
            <>
              <Button onClick={closeModal} variant="outlined">
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSubmit}>
                Confirm
              </Button>
            </>
          ) : (
            <CircularProgress size={25} />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteNotificationModal;
